import { reducerWithInitialState } from "typescript-fsa-reducers";
import { ScreenSize } from "../utils/media";
import { screenSizeChanged } from "../actions/Media";
import withImmer from "../../lib/withImmer";

export interface MediaState {
  screenSize: ScreenSize;
}

const initialState: MediaState = {
  screenSize: "small",
};

const mediaReducer = withImmer(reducerWithInitialState(initialState)).case(screenSizeChanged, (state, screenSize) => {
  state.screenSize = screenSize;
  return state;
});

export default mediaReducer;



// WEBPACK FOOTER //
// ./frontend/src/common/reducers/media.ts